import ProductCollectionPage from "../common/ProductCollectionPage";

const Shirts = ({ onAddToCart }) => (
  <ProductCollectionPage
    seo={{
      title: "Dress Shirts",
      description: "Shop shirts on Emporia, a Kenyan online marketplace. Pay securely with M-Pesa and get delivery across Kenya.",
      path: "/shirts",
    }}
    query="category=shirts"
    eyebrow="Collection"
    heading="Shirts"
    tagline="Shop shirts from local sellers, with secure M-Pesa payment and delivery across Kenya."
    onAddToCart={onAddToCart}
  />
);

export default Shirts;
